module.exports = __webpack_public_path__ + "p8_img1.jpg?e71847bc9eee044cb78f6b1410fd1ba7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p8/p8_img1.jpg
// module id = 132
// module chunks = 0